import Vue from 'vue';
import Router from 'vue-router';
import PageHome from '../pages/PageHome.vue';
import PageLogin from '../pages/PageLogin';
import PageForgetPassword from '../pages/PageForgetPassword';
import PageResetPassword from '../pages/PageResetPassword';
import PageRegistration from '../pages/PageRegistration';
import store from '../store';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: {
        onlyAuthUser: true
      }
    },
    {
      path: '/resetPassword',
      name: 'PageResetPassword',
      component: PageResetPassword,
      meta: {
        onlyGuestUser: true
      }
    },
    {
      path: '/forgetPassword',
      name: 'PageForgetPassword',
      component: PageForgetPassword,
      meta: {
        onlyGuestUser: true
      }
    },
    {
      path: '/login',
      name: 'PageLogin',
      component: PageLogin,
      meta: {
        onlyGuestUser: true
      }
    },

    {
      path: '/managers',
      name: 'managers',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tables" */ '../pages/PageUsers.vue'),
      meta: {
        onlyAuthUser: true
      }
    },
    {
      path: '/users',
      name: 'Users',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tables" */ '../pages/PageCitizens.vue'),
      meta: {
        onlyAuthUser: true
      }
    },
    // {
    //   path: '/logout',
    //   name: 'Logout',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "tables" */ '../pages/PageLogout.vue'),
    //   meta: {
    //     onlyAuthUser: true
    //   }
    // },
    {
      path: '/users/:id',
      name: 'user_details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tables" */ '../pages/PageCitizenView.vue'),
      meta: {
        onlyAuthUser: true
      }
    },
    {
      path: '/profile',
      name: 'profile',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tables" */ '../pages/PageProfile.vue'),
      meta: {
        onlyAuthUser: true
      }
    },
    {
      path: '/create',
      name: 'create',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "tables" */ '../pages/PageRegistration.vue'),
      meta: {
        onlyAuthUser: true
      }
    },
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// router.beforeEach((to, from, next) => {
//   store.dispatch('auth/getAuthUser').then(authUser => {
//     if (to.meta.onlyAuthUser) {
//       if (store.getters['auth/isAuthenticated']) {
//         next();
//       } else {
//         next({ name: 'PageLogin' });
//       }
//     } else if (to.meta.onlyGuestUser) {
//       if (store.getters['auth/isAuthenticated']) {
//         next({ name: 'PageHome' });
//       } else {
//         next();
//       }
//     } else {
//       next();
//     }
//   });
// });


router.beforeEach((to, from, next) => {
  store.dispatch('auth/getAuthUser').then(authUser => {
    if (to.meta.onlyAuthUser) {
      if (store.getters['auth/isAuthenticated']) {
        next();
      } else {
        next({ name: 'PageLogin' });
      }
    } else if (to.meta.onlyGuestUser) {
      if (store.getters['auth/isAuthenticated']) {
        next({ name: 'PageHome' });
      } else {
        next();
      }
    } else {
      next();
    }
  });
});

export default router;
